import { isPlatformBrowser, Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  TemplateRef,
  ChangeDetectionStrategy,
  NgZone,
  Inject,
  afterNextRender,
  AfterViewInit,
  PLATFORM_ID,
  HostBinding,
  effect
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { faBars, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { AutoComplete } from 'primeng/autocomplete';
import { Menu } from 'primeng/menu';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, take, takeUntil } from 'rxjs/operators';

import { ENVIRONMENT, Environment } from '@environment';
import { AuthService } from '@usheru-hff/authentication/domain';
import { MyActivityService } from '@usheru-hff/community-elements/utils';
import { ChannelService } from '@usheru-hff/sdk/channel';
import { HeaderService } from '@usheru-hff/sdk/header';
import { Channel, Movie, PageLink, SocialNetworkLink, UserRole } from '@usheru-hff/shared/domain';
import { PopupCustomPageService, TemplatesService, ThemeService } from '@usheru-hff/shared/utils';
import { CollectionRoutesEnum as Routes } from '@usheru-hff/shared/utils-community';
import { NavigationService } from '@usheru-hff/shared/utils-navigation';
import { TrackingService } from '@usheru-hff/sdk/tracking';

import { HEADER_ANIMATION } from './header.animation';

/**
 * @docsNotRequired
 * //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.
 * //TODO barbeitoalex propostal - use environment values in their own method and subscribe to environment changes
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: HEADER_ANIMATION,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @HostBinding('style.display') displayStyle: 'block' | 'none';

  /**
   * List of {@link AutoComplete} inside the {@link SearchMovieComponent}. Should be one
   * in the normal header and other in the small header.
   */
  @ViewChildren('autocomplete_movie', { read: AutoComplete })
  autocomplete: QueryList<AutoComplete>;

  /**
   * @deprecated Don't found any use
   */
  @ViewChild('searchItem')
  searchItemRef: ElementRef;

  /**
   * @deprecated Don't found any use
   */
  @ViewChild('menu')
  menu: Menu;

  /**
   * Indicates if is seletected the normal o smal header.
   */
  isCollapse = false;

  /**
   * Indicates if the translation widget should be in the collapsed menu (mobile).
   */
  hasCollapsedTranslation = false;

  /**
   * FontAwsome icon
   */
  toggleIcon = faBars;

  /**
   * @deprecated Don't found any use
   */
  spanCollapse = false;

  /**
   * @deprecated Don't found any use
   */
  spanFullTransparency = true;

  /**
   * Logo image
   */
  logoUrl: string;

  /**
   * Reddirection of the logo. Can be internal or external. No options to be null.
   */
  logoLink: string;

  /**
   * Fragment attache to the {@link logoLink}.
   */
  logoFragment: string;

  /**
   * Params to render the {@link logoUrl}
   */
  logoParams: { width?: number; height?: number };

  /**
   * Indicate if the {@link logoLink} is a internal or external link.
   */
  logoLinkExternal = false;

  /**
   * @deprecated Don't found any use
   */
  isSearch = false;

  /**
   * @deprecated Don't found any use
   */
  isStyleClip = false;

  /**
   * @deprecated Don't found any use
   */
  searchIcon = faSearch;

  /**
   * @deprecated Don't found any use
   */
  movie: Movie;

  /**
   * List of movie to show in the {@link SearchMovieComponent}.
   */
  movieSuggestions: Movie[];

  /**
   * Indicates if is in a branded movie menu for small devices.
   */
  onMovieMenu = true;

  /**
   * Links to show in the menu.
   */
  links: PageLink[] = [];

  /**
   * Indicate if the must show the social icons. This is set from enviroment settings.
   */
  hasSocialLinks = false;

  /**
   * List of social links to display.
   */
  socialLinks: SocialNetworkLink[] = [];

  /**
   * @deprecated Don't found any use
   */
  homePage: string;

  /**
   * @docsNotRequired
   */
  faTimes = faTimes;

  /**
   * Movie to get some properties when branded movie menu.
   */
  brandedMovie: Movie | null;

  /**
   * If it is in branded page get the links for the custom menu for this pages.
   */
  brandedPageLinks: PageLink[] = [];

  /**
   * If it is in branded page get the styles for the custom menu for this pages.
   */
  _brandedPageMenuStyle: string;

  brandStyleInBody: HTMLElement;

  get brandedPageMenuStyle(): string {
    return this._brandedPageMenuStyle;
  }

  set brandedPageMenuStyle(x: string | null) {
    if (!this.isBrowser) return;
    if (x) {
      this._brandedPageMenuStyle = `<style type="text/css">${x.replace(/\r?\n|\r|(\s\s\s*)/g, '')}</style>`;
      this.brandStyleInBody = document.createElement('style');
      this.brandStyleInBody.innerHTML = x;
      const body = document.getElementsByClassName('route-branded-movie')[0];
      if (body) body.appendChild(this.brandStyleInBody);
    } else {
      this._brandedPageMenuStyle = x;
    }
  }

  /**
   *  Used for redirection after login/register process.
   */
  returnUrl: string;

  //
  /**
   * Custom template provided by {@link TemplatesService} to add custom entries in the header menu.
   */
  headerCustomLinkTemplate: TemplateRef<unknown>;

  /**
   * Reference to "this" component to use in the {@link headerCustomLinkTemplate}.
   */
  headerInstance: unknown;

  /**
   * @docsNotRequired
   */
  channel: Channel;

  /**
   * Indicates if the user is at the top of the page.
   */
  atScrollTop = true;

  destroy$ = new Subject<boolean>();

  constructor(
    private location: Location,
    private authenticationService: AuthService,
    private themeService: ThemeService,
    @Inject(ENVIRONMENT) private env: Environment,
    @Inject(PLATFORM_ID) private platform,
    private router: Router,
    private navigationService: NavigationService,
    private channelService: ChannelService,
    private ref: ChangeDetectorRef,
    private popupCustomPage: PopupCustomPageService,
    private templatesService: TemplatesService,
    private zone: NgZone,
    private cd: ChangeDetectorRef,
    private trackingService: TrackingService,
    private myActivityService: MyActivityService,
    private headerService: HeaderService
  ) {
    effect(() => {
      this.displayStyle = this.headerService.displayStyle();
      this.cd.markForCheck();
    });
    //
    this.channel = this.channelService.channel;

    const logoConfig = this.env?.logosConfig?.header;
    this.hasCollapsedTranslation = this.env.customPageParams?.headerSMtranslationCollapsed;
    this.logoLink = logoConfig?.logoLink || '/home';
    this.logoFragment = logoConfig?.logoFragment;
    this.logoLinkExternal = this.logoLink.indexOf('http') == 0;
    this.logoUrl = logoConfig?.logoUrl || this.channel.logoUrl;
    const { width, height } = logoConfig || {};
    this.logoParams = { width, height };

    this.homePage = this.channel.homePage.replace('/page', '');
    this.hasSocialLinks = this.env?.customPageParams?.headerSocialLinks;
    if (this.hasSocialLinks) {
      this.socialLinks = this.channel.socialNetworks.filter(sn => sn.showLink);
    }
    afterNextRender(() => {
      this.addScrollListener();
    });
  }
  ngAfterViewInit(): void {
    this.listenForUserChanges();
  }

  /**
   * * Sets the menu {@link links}.
   *
   * * Subscribe to {@link userSubscription}.
   *
   * * Make a subscription to {@link router} and update returnUrl of login widget accordlyng and reset active header link
   * in case it doesn't match the url.
   *
   * * Load header custom template if any.
   */
  ngOnInit(): void {
    this.headerInstance = this;
    this.links = JSON.parse(JSON.stringify(this.navigationService.getHeaderLinks()));

    this.links = this.links
      .filter(link => link.visibility == 3)
      .sort((a, b) => a.order - b.order)
      .map(link => {
        if (link.link.indexOf('http') == 0) {
          link.isExternal == true;
          return link;
        }
        const params = link.link.split('?')[1]?.split('&') || [];
        const paramsToSave = [];
        params.forEach(p => {
          const split = p.split('=');
          const name = split[0];
          const value = split[1] || '';
          switch (true) {
            case name == 'parent' && value.length > 0:
              link.parent = value;
              break;
            case name == 'popup':
              link.isPopup = true;
              break;
            default:
              paramsToSave.push(p);
          }
        });
        if (paramsToSave.length > 0) {
          link.params = paramsToSave.reduce((pre, cur) => {
            const split = cur.split('=');
            pre[split[0]] = split[1];
            return pre;
          }, {});
        }

        link.link = link.link?.split('?')[0];

        return link;
      });

    // Prepare submenus
    this.links.forEach((link, i) => {
      if (link?.parent) {
        const parent = this.links.findIndex(l => l?.name === link?.parent);
        // if parent link doesn't exit replace this as the parent.
        // And add the link as a child
        if (parent === -1) {
          const child = { ...link };
          link.name = link.parent;
          link.link = null;
          link.isParent = true;
          link.parent = null;
          link.children = [child];
          this.links[i] == link;
        } else {
          // Adds link to his parent and return null to delete later
          const childrens = this.links[parent]?.children || [];
          childrens.push(link);
          this.links[parent].children = childrens;
          if (link.isActive) this.links[parent].isActive = true;
          this.links[i] = null;
        }
      }
    });

    // Remove nulls
    this.links = this.links.filter(n => n);

    // addying community header link group if community role is present
    const communityRole = this.channelService.getCommunityRoleAvailable();
    if (communityRole) this.links.push(this.getMyActivityLinkGroup());

    this.returnUrl = this.router.url;
    //
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        distinctUntilChanged()
      )
      .subscribe((route: NavigationEnd) => {
        let linksActive = 0;
        const urlAfterRedirects = route.urlAfterRedirects.split('?')[0];
        this.links = this.links.map(link => {
          if (link?.isParent && link?.children) {
            link.isActive = link.children.find(l => l.link == urlAfterRedirects) ? true : false;
            link.children = link.children.map(l => {
              l.isActive = l.link.split('?')[0] == urlAfterRedirects;
              return l;
            });
          } else {
            link.isActive = link?.link?.split('?')[0] == urlAfterRedirects;
            // making sure there is only 1 link active
            if (link.isActive) linksActive++;
            if (linksActive > 1) link.isActive = false;
          }
          return link;
        });

        this.returnUrl = this.router.url;

        this.cd.detectChanges();
      });

    // subscribing to isBrandedPage
    this.themeService
      .getBrandedMovie()
      .pipe(takeUntil(this.destroy$))
      .subscribe(movie => {
        this.brandedMovie = movie;
      });

    this.themeService
      .getBrandedPageLinks()
      .pipe(takeUntil(this.destroy$))
      .subscribe(links => {
        this.brandedPageLinks = links;
        this.cd.detectChanges();
      });
    this.themeService
      .getBrandedMobileMenuStyle()
      .pipe(takeUntil(this.destroy$))
      .subscribe(style => {
        this.brandedPageMenuStyle = style;
      });

    this.loadHeaderCustomTemplate();
  }

  addScrollListener() {
    this.zone.runOutsideAngular(() => {
      window.addEventListener('scroll', () => {
        this.atScrollTop = window.pageYOffset == 0;
      });
    });
  }

  isExternalLink(link: string): boolean {
    return link.indexOf('http') == 0;
  }

  /**
   * Gets from enviroment if the header should be fixed.
   * @returns
   */
  hasHeaderFixed(): boolean {
    return this.env?.customPageParams?.headerFixed;
  }

  /**
   * Change the status of the small header to show the menu items.
   * @param value
   */
  toggleNavbar(value?: boolean) {
    this.isCollapse = value ? value : !this.isCollapse;
    this.toggleIcon = this.isCollapse ? faTimes : faBars;

    if (!this.isCollapse) {
      this.spanFullTransparency = true;
      setTimeout(() => (this.spanCollapse = false), 300);
    } else {
      this.spanCollapse = true;
      setTimeout(() => (this.spanFullTransparency = false), 100);
    }
    if (this.isCollapse) {
      document.getElementsByTagName('body')[0].classList.add('no-overflow');
    } else {
      document.getElementsByTagName('body')[0].classList.remove('no-overflow');
    }
  }

  /**
   * Lauches intructions to the {@link PopupCustomPageService} to show this direction as popup.
   * @param link
   * @returns
   */
  onLinkClick(link: PageLink) {
    if (link?.isPopup) {
      const component = link.link;
      if (component.indexOf('/') === 0) component.slice(1);
      this.popupCustomPage.pushTrigger(component);
      return;
    }

    if (!link?.isExternal) {
      this.toggleNavbar();
    }
  }

  /**
   * @deprecated Don't found any use
   */
  toggleSearchBar() {
    this.isStyleClip = true;
    setTimeout(() => {
      this.isSearch = !this.isSearch;
      this.searchIcon = this.isSearch ? faTimes : faSearch;
      this.ref.detectChanges();

      if (this.isSearch) {
        this.getMovieSearchAutocomplete();

        setTimeout(() => (this.isStyleClip = false), 600);
      }
    }, 10);
  }

  /**
   * Gets the active {@link AutoComplete} {@link SearchMovieComponent}
   * @returns
   */
  getMovieSearchAutocomplete(): AutoComplete {
    return window.innerWidth < 992 // is mobile header
      ? this.autocomplete.first
      : this.autocomplete.last;
  }

  /**
   * @deprecated Don't found any use
   */
  getClasses(specialClass) {
    const classes = ['nav-link'];
    if (specialClass !== undefined) {
      classes.push(specialClass);
    }
    return classes;
  }

  /**
   * @deprecated Don't found any use
   */
  findElem(url: string): PageLink {
    return this.links.find(elem => elem.link.localeCompare(url) == 0);
  }

  listenForUserChanges() {
    this.authenticationService.$userStatus.pipe(takeUntil(this.destroy$)).subscribe(user => {
      if (user) {
        this.serializeLinks();
      }
    });
  }

  /**
   * Gets from environment if show the search in the small header.
   */
  get headerSMsearchTop() {
    return this.env.customPageParams?.headerSMsearchTop;
  }

  /**
   * Gets from enviroment if show the search in the menu of the small header.
   */
  get headerSMsearchCollapse() {
    return this.env.customPageParams?.headerSMsearchCollapse;
  }

  /**
   * Gets from environment if show the {@link LanguageSelectorComponent} in the header.
   */
  get hasTranslationHeader() {
    const hasTranslationHeader = this.env.customPageParams?.translationHeader;
    if (typeof hasTranslationHeader !== 'undefined') {
      return hasTranslationHeader;
    }
    return false;
  }

  get isBrowser() {
    return isPlatformBrowser(this.platform);
  }

  /**
   * Used when the user clicks the logo to removed the enabled classes.
   */
  onGoHome() {
    this.links.forEach(elem => {
      elem.isActive = false;
    });
  }

  /**
   * Changes the section in a branded page.
   * @param pageLink
   */
  gotoSection(pageLink: PageLink) {
    // set this link as active
    pageLink.isActive = true;
    // set the other links as inactive
    this.brandedPageLinks.forEach(link => {
      if (link.name != pageLink.name) link.isActive = false;
    });
    // hide menu
    this.toggleNavbar();
    // update themeservice menu link selected observable
    if (pageLink?.link) {
      this.router.navigateByUrl(pageLink.link);
    } else {
      this.themeService.setSectionSelected(pageLink.name);
    }
  }

  loadHeaderCustomTemplate() {
    const headerCustomLinkTemplate = this.env?.templateRefs?.headerCustomLinkTemplate;
    if (headerCustomLinkTemplate) {
      this.headerCustomLinkTemplate = this.templatesService.get(headerCustomLinkTemplate);
    }
  }

  /**
   * Gets from environment if the login is enabled.
   */
  get hasLogin() {
    if (this.isCommunityFeaturesEnabled) return true;
    const hasLogin = this.env.customPageParams?.login;
    if (typeof hasLogin !== 'undefined') {
      return hasLogin;
    }
    return false;
  }

  onHeaderLinkClicked(link: PageLink) {
    this.trackingService.trackEvent({
      action: 'HeaderLink',
      properties: {
        category: 'Header',
        label: link.name
      }
    });
    if (link.command && !link.command()) return;
    if (link.children) link.isActive = true;
  }

  onHeaderLogoClicked() {
    this.trackingService.trackEvent({
      action: 'BrandLogo',
      properties: {
        category: 'Header',
        label: this.channel.name
      }
    });
  }

  getMyActivityLinkGroup() {
    const activityLinkGroup = this.myActivityService.getMyActivityLinkGroup(true);
    activityLinkGroup.children.forEach(link => {
      link.link = link.url;
    });
    return activityLinkGroup;
  }

  get isCommunityFeaturesEnabled() {
    return this.channelService.isRolePresent(UserRole.community);
  }

  getNormalizedUrl(link: PageLink): string {
    return this.normalizeRoute(!link?.isParent && !link?.isPopup && !link?.isExternal ? link.link : null);
  }

  normalizeRoute(route: string): string {
    return route?.replace(':' + Routes.USER_ID, this.authenticationService.getUserUsername());
  }

  serializeLinks() {
    this.links.forEach(link => {
      link.link = this.normalizeRoute(link.link);
      if (link.children) {
        link.children.forEach(childLink => {
          childLink.link = this.normalizeRoute(childLink.link);
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
